import React, { useContext } from "react";

/// React router dom
import { Routes, Route, Outlet, useLocation, useNavigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
import Header from "./layouts/nav/Header";
import BottomNav from "./layouts/nav/BottomNav";

/// Pages

import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Setting from "./layouts/Setting";
import { ThemeContext } from "../context/ThemeContext";
import { AuthContext } from "../context/AuthContext";
import { adminRoutes, allAdminroutes } from "../routes/AdminRoutes";
import { allUserroutes } from "../routes/UserRoutes";
import { allVenueManagerroutes } from "../routes/VenueManager";
import ForceLogout from "../admin/admincomponent/forceLogout/ForceLogout";
import BookingDetails from "../venueManager/BookingDetails";
import TicketDetails from "../venueManager/TIcketDetails";
import MyEvents from "../venueManager/MyEvents";
import { useMenuManagement } from "../context/MenuManagementContext";
import { useSelector } from "react-redux";

const Markup = () => {

  const internalRoutes = [
    "verification-form/:id",
    "verification-Individual-form/:id",
    "organization-verification/:id",
    "verification-view-form/:id",
    "verification-insitute-view-form/:id",
    "edit-profile-request-view/:id",
    "account/account-profile/:id",
    "account/role/update/:id",
    "account/role-assign/:id",
    "booking-details/:id",
    "ticket-details/:id",
    "payment-summary",
    "manager-ticket-details",
    "batch-management/dashboard",
    "batch-management/batches/add",
    "batch-management/batches/viewBatch/:id",
    "batch-management/batches/update/:id",
    "batch-management/calendar/update/:id",
    "batch-management/calendar/create-training",
    "uddyamaan-unnayan-yojana/assessment/:id",
    "protsaahan-yojana/assessment/:id",
    "cm-trophy/applications/:id"
  ];
  const userType = localStorage.getItem("user_type");
  const { loading, menuDataList, fetchMenuList, setMenuId, menuId } = useMenuManagement();
  const { user, USER_LEVEL } = useContext(AuthContext);
  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
  const userId = loginDetails?.user?.id;
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  const Navigate = useNavigate();

  const permissionRoutes =
    JSON.parse(localStorage.getItem("permission_route_url")) || [];


  let routeType = [];

  if (user?.role === "admin") {
    if (user?.user_level == USER_LEVEL.ADMIN) {
      routeType = allAdminroutes;
    }
    if (
      user?.user_level == USER_LEVEL.SUB_ADMIN ||
      [6, 7, 9, 10, 11, 12].includes(Number(user?.user_level))
    ) {
      const allExternal = permissionRoutes.every((route) =>
        /^https?:\/\//i.test(route)
      );

      const currentRoute = window.location.pathname.replace(/^\/+/, "");

      const routeExistsInAdmin = allAdminroutes.some(
        (route) => route.url === currentRoute
      );

      // if (routeExistsInAdmin && !permissionRoutes.includes(currentRoute)) {
      //   // redirect to profile page
      //    Navigate(`/account/account-profile/${userId}`, { replace: true });

      //   routeType = allAdminroutes.filter(
      //     (route) => route.url === "account/account-profile/:id"
      //   );
      // }
      const isInternalRoute = internalRoutes.some((route) => {
        const regex = new RegExp(
          "^" + route.replace(":id", "[^/]+") + "$"
        );
        return regex.test(currentRoute);
      });

      if (
        routeExistsInAdmin &&
        !permissionRoutes.includes(currentRoute) &&
        !isInternalRoute
      ) {
        // redirect to profile page
        Navigate(`/account/account-profile/${userId}`, { replace: true });

        routeType = allAdminroutes.filter(
          (route) => route.url === "account/account-profile/:id"
        );
      }

      else if (allExternal) {
        routeType = allAdminroutes.filter(
          (route) => route.url === "account/account-profile/:id"
        );
      }
      else {
        routeType = allAdminroutes.filter((route) =>
          permissionRoutes.includes(route.url) || internalRoutes.includes(route.url)
        );
      }
    }
  }

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route path="/force-logout" element={<ForceLogout />} />
        <Route path="no-permission" element={<LockScreen />} />

        {/* <Route path="*" element={<Error404 />} /> */}
        {/* ✅ Add your route here */}

        {/* <Route path="profile" element={<ProfileComp />} /> */}
        {/* {useCheckRoute() && <Route path="*" element={<Error404 />} />} */}

        <Route element={<MainLayout />}>
          <Route path="/booking-details/:id" element={<BookingDetails />} />
          <Route path="/ticket-details/:id" element={<TicketDetails />} />
          {routeType?.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}


          {userType === "user" &&
            allUserroutes?.map((data, i) => (
              <Route
                key={i}
                exact
                path={`${data.url}`}
                element={data.component}
              />
            ))}

          {user?.role === "admin" &&
            user.category_id === process.env.REACT_APP_TICKETING_MANAGER_ID &&
            allVenueManagerroutes?.map((data, i) => (
              <Route
                key={i}
                exact
                path={`${data.url}`}
                element={data.component}
              />
            ))}
          {/* {routeType?.length > 0 && (
            <Route path="*" element={<Error404 />} />
          )} */}
        </Route>
      </Routes>
      <Setting />
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  const { user } = useContext(AuthContext);
  const isSidebarOpen = useSelector((state) => state.ui.isSidebarOpen);
  const isAdminLayout = user?.role === "admin";

  const closeSidebar = () => {
    const wrapper = document.querySelector("#main-wrapper");
    if (wrapper && wrapper.classList.contains("menu-toggle")) {
      wrapper.classList.remove("menu-toggle");
    }
  };

  if (isAdminLayout) {
    return (
      <div id="main-wrapper" className="show no-sidebar-layout">
        <Header hideHamburger />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 45 }}
        >
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${menuToggle ? "menu-toggle" : ""
        }`}
    >
      <div className="sidebar-backdrop" onClick={closeSidebar} />
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className={`${isSidebarOpen ? "container-fluid" : "container-fluid-collapse"}`}>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Markup;
